import * as actionType from "./constants";

const initialState = {
    getMasterProjectSettingsTemplateByIdResponse: null
};

const reducers = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_GLOBAL_PROJECT_SETTINGS_TEMPLATE_BY_ID_REQUEST:
            return {
                ...state,
                getMasterProjectSettingsTemplateByIdResponse: { isLoading: true }
            };
        case actionType.GET_GLOBAL_PROJECT_SETTINGS_TEMPLATE_BY_ID_SUCCESS:
            return {
                ...state,
                getMasterProjectSettingsTemplateByIdResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_GLOBAL_PROJECT_SETTINGS_TEMPLATE_BY_ID_FAILURE:
            return {
                ...state,
                getMasterProjectSettingsTemplateByIdResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.RESET_MASTER_SETTINGS_TEMPLATE_REDUCER:
            return {
                ...state,
                getMasterProjectSettingsTemplateByIdResponse: null
            };
        default:
            return state;
    }
};
export default reducers;
